import { Component, OnInit } from '@angular/core';
import { FnToasterService } from 'foundation';
import { UtilitySetupService } from './utility-setup.service';

@Component({
  selector: 'app-utility-setup',
  templateUrl: './utility-setup.component.html',
  styleUrls: ['./utility-setup.component.scss']
})
export class UtilitySetupComponent implements OnInit {

  objectHash: utilitySetup = {
    telegramgroupList: [],
    eventIdList: [],
    eventIdsForHost: [],
    schemaList: [],
    clocksiteSchema: [],
    allEnvList: [],
    offlineCLockQuery_pg: '',
    siteOfflineClkQuery_pg: '',
    appStartupQuery_pg: '',
    sltList: []
  }

  constructor(
    private toasterService: FnToasterService,
    private utilitySetupService: UtilitySetupService,
    private toaster: FnToasterService
  ) { }

  ngOnInit(): void {
    this.utilitySetup();
  }

  utilitySetup(): void {
    this.utilitySetupService.getUtilitySetup().subscribe(resp => {
      if (resp.isError) {
        this.toaster.error(resp.message);
        return;
      }
      this.objectHash = resp.data;
    });
  }

  addGroup(): void {
    this.objectHash.telegramgroupList = this.objectHash.telegramgroupList || [];
    this.objectHash.telegramgroupList.push({
      severity: '',
      group: ''
    });
  }

  addEventIds(): void {
    this.objectHash.eventIdList = this.objectHash.eventIdList || [];
    this.objectHash.eventIdList.push({
      name: '',
      friendlyName: ''
    });
  }

  addHostEventIds(): void {
    this.objectHash.eventIdsForHost = this.objectHash.eventIdsForHost || [];
    this.objectHash.eventIdsForHost.push({
      name: '',
      friendlyName: ''
    });
  }

  addSchema(): void {
    this.objectHash.schemaList = this.objectHash.schemaList || [];
    this.objectHash.schemaList.push({
      name: '',
      friendlyName: ''
    });
  }

  addClockSchema(): void {
    this.objectHash.clocksiteSchema = this.objectHash.clocksiteSchema || [];
    this.objectHash.clocksiteSchema.push({
      name: '',
      friendlyName: ''
    });
  }

  addEnvList(): void {
    this.objectHash.allEnvList = this.objectHash.allEnvList || [];
    this.objectHash.allEnvList.push({
      name: '',
      url: ''
    });
  }

  addSltList(): void {
    this.objectHash.sltList = this.objectHash.sltList || [];
    this.objectHash.sltList.push({
      sev: '',
      hour: ''
    });
  }

  saveData() {
    this.updateUtlitySetup(this.objectHash);
  }

  updateUtlitySetup(objectHash: utilitySetup) {
    this.utilitySetupService.updateUtilitySetup(objectHash).subscribe(resp => {
      if (resp.isError) {
        this.toaster.error(resp.message);
        return;
      }
      this.toaster.success("Utility Setup is Updated Succesfully")
    }
    );
  }

  deleteRow(index: number): void {
    if (index > -1 && index < this.objectHash.telegramgroupList.length) {
      this.objectHash.telegramgroupList.splice(index, 1);
    }
  }

  deleteEvent(index: number): void {
    if (index > -1 && index < this.objectHash.eventIdList.length) {
      this.objectHash.eventIdList.splice(index, 1);
    }
  }

  deleteHostEvent(index: number): void {
    if (index > -1 && index < this.objectHash.eventIdsForHost.length) {
      this.objectHash.eventIdsForHost.splice(index, 1);
    }
  }

  deleteSchema(index: number): void {
    if (index > -1 && index < this.objectHash.schemaList.length) {
      this.objectHash.schemaList.splice(index, 1);
    }
  }

   deleteClockSchema(index: number): void {
    if (index > -1 && index < this.objectHash.clocksiteSchema.length) {
      this.objectHash.clocksiteSchema.splice(index, 1);
    }
  }

  deleteEnvList(index: number): void {
    if (index > -1 && index < this.objectHash.allEnvList.length) {
      this.objectHash.allEnvList.splice(index, 1);
    }
  }

  deleteSltList(index: number): void {
    if (index > -1 && index < this.objectHash.sltList.length) {
      this.objectHash.sltList.splice(index, 1);
    }
  }
  
  reload() {
    this.utilitySetupService.reload().subscribe(resp => {
      if (resp.isError) {
        this.toaster.error(resp.message);
        return;
      }
    });
  }

}

export interface utilitySetup {
  telegramgroupList: any[],
  eventIdList: any[],
  eventIdsForHost: any[],
  schemaList: any[],
  clocksiteSchema: any[],
  allEnvList: any [],
  offlineCLockQuery_pg: string,
siteOfflineClkQuery_pg: string,
appStartupQuery_pg: string,
sltList: any [],
}
